import React from "react";

const Agric = () => {
  return (
    <div>
      <section
        id="page-title"
        className="page-title page-title-layout10 bg-overlay bg-parallax text-center"
      >
        <div className="bg-img">
          <img src="../assets/images/page-titles/13.jpg" alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <h1 className="pagetitle__heading">Transportation</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/products">Products</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Transportation
                  </li>
                </ol>
              </nav>
            </div>
            {/* /.col-lg-12 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
      {/* /.page-title */}
      {/* ======================
        Text Content Section
      ========================= */}
      <section id="textContentSection" className="text-content-section">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-2" />
            <div className="col-sm-12 col-md-12 col-lg-8">
              <div className="text__block">
                <h5 className="text__block-title">Transportation</h5>
                <p>
                  <img alt="ima" height="150" src="/assets/images/products/bike1.png" width="187" />
                  Motorcycles
                </p>
                <p>
                  We are exclusively partners with Company, Companies from
                  India, China to assemble, market, distribute and provide
                  service for their range of motorcycles in Nigeria. We are
                  official the fastest growing motorcycle brand in Nigeria.
                </p>
                <p>
                  We have a strong emphasis on local value addition achieved
                  through local assembly of the vehicles, as well as extensive
                  investments in our network of sales and service centers across
                  the country. We have a training center located at our factory
                  in Lagos which is responsible for training thousands of
                  mechanics and automobile engineers from across the country.
                </p>
                <p>
                  <img alt="ran i" height="199" src="/assets/images/products/tricycle.png" width="292" />
                </p>
                <b>Tricycle</b>
                <p>
                  the sole distributor of the leading three-wheeler (tricycle)
                  in Nigeria and official sponsor of the Super Eagles. Our
                  products are manufactured by India, China one of the largest
                  manufacturers of two and three wheelers in the world. At the
                  heart of our offering is a commitment to quality and service,
                  and the tremendous success of the vehicle in Nigeria is indeed
                  testament to that.
                </p>
                <p>
                  A key part of achieving this is through our training of
                  thousands of mechanics and engineers based in every part of
                  the country. We have a strong emphasis on local value addition
                  achieved through local assembly of the vehicles, as well as
                  extensive investments in our network of sales and service
                  centers across the country.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  <br />
                </p>
                <p>
                  <img alt="dd t" height="210" src="/assets/images/products/bicycle.png" width="275" />
                  Bicycles
                </p>
                <p>
                  Bicycles is where our story started, and thirty years later we
                  remain the leading bicycle company in Nigeria. Having
                  exclusively represented brands we have penetrated every corner
                  of Nigeria with our one-stop wholesale-shop for bicycles.
                </p>
                <p>
                  Today we offer the market a range of cycles that represents
                  our thirty-year understanding of the Nigerian bicycle user and
                  it’s no surprise that we are number one! Our range includes a
                  comprehensive portfolio of cycles, ranging from kids’ bikes to
                  Mountain Bikes, as well as so-called ‘traditional ‘cycles.
                </p>
                <p>
                  <img
                    alt="A containing designDescription automatically generated with low confidence"
                    height="150"
                    src="/assets/images/products/oil.png"
                    width="293"
                  />
                </p>
                <p>Engine Oil</p>
                <p>
                  Our Super is a high-quality, SL-grade engine oil carefully
                  blended with the industry’s best hot blending process with
                  carefully selected Chevron additives required by Original
                  Equipment Manufacturers (OEMs) to improve motorcycle and
                  tricycle engine performance and guarantee 30-day extended
                  engine protection.
                </p>
                <p>
                  Our super engine oil is blended in Nigeria, with local
                  operating conditions in mind, and approved by STANDARD
                  ORGANISATION OF NIGERIA (SON). This approval provides a
                  guarantee for engine protection and product assurance.
                </p>
                <p>
                  <img
                    alt="A row of buses parked in a parking lotDescription automatically generated with low confidence"
                    height="230"
                    src="/assets/images/products/brt.png"
                    width="410"
                  />
                </p>
                <p>Transportation</p>
                <p>
                  Bus Rental Service offers an efficient bus rental service with
                  driver for company transfers. School trips, transport for
                  events and conferences our company has remarkable achievement
                  in transportation.
                </p>
              </div>
              {/* /.text-block */}
            </div>
            {/* /.col-lg-8 */}
            <div className="col-sm-12 col-md-12 col-lg-2" />
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
    </div>
  );
};

export default Agric;
